import Axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from "react-router-dom";
import Select from 'react-select';
import DateRangeSelect from '../Common/DateRangeSelect';
import { hasAnyRole } from '../Common/functions';
import { ISelectOption, ProjectData, ROLES_LIST } from "../Common/types";
import { URLParamsReader } from "../Common/URLParamsReader";
import TextSearchField from '../Notifications/TextSearchField';
import { AllProgressStatuses } from '../TaskManage/StatusField';
import BottomMenu from './BottomMenu';
import HeaderDefault from './HeaderDefault';
import HeaderWoodParts from './HeaderWoodParts';
import TableRowDefault from './TableRowDefault';
import TableRowWoodParts from './TableRowWoodParts';

function formatDate(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
}





interface ISearchContext {
  sortBy: (column: string) => void,
  getSortIcon: (column: string) => string
}

// export const SearchContext = React.createContext(
//   [{ sortBy: (column: string) => { }, getSortIcon: (column: string) => '' }, (c: ISearchContext) => { }] as [ISearchContext, Dispatch<SetStateAction<ISearchContext>>]);

export const SearchContext = React.createContext<ISearchContext>({} as ISearchContext);


interface ListProps extends RouteComponentProps<any> {
  history: string[],
  location: { pathname: string, search: string },
  roles: string[],
}

export const TT_FLOOR_BEARERS = "1"
export const TT_WALL_BEAMS = "2"
export const TT_PURLINS = "3"
export const TT_ROOF = "4"
export const TT_WINBOARDS_TRIMS = "5"
export const TT_STAIRS = "6"
export const TT_WOODEN_PARTS = "1,2,3,4,5,6"

const WOOD_PART_TYPES: ISelectOption[] = [
  { label: "Floor bearers", value: TT_FLOOR_BEARERS },
  { label: "Wall logs", value: TT_WALL_BEAMS },
  { label: "Purlins, beams & columns", value: TT_PURLINS },
  { label: "Floor & roof boards", value: TT_ROOF },
  { label: "Terrace boards", value: TT_WINBOARDS_TRIMS },
  { label: "Stairs & fences", value: TT_STAIRS },
]
export const TT_WINDOWS = "7"
export const TT_INSULATION = "8"
export const TT_INSTALLATION = "9"
export const TT_ROOF_COVERS = "10"
export const TT_IMPREGNATION = "11"
export const TT_PACKAGING = "12"

const ALL_ROWS = 100000


const List = (props: ListProps) => {

  const requestIdRef = useRef(0);

  const urlParams = new URLParamsReader(props.location.search, "status=1,CONFIRMED:2,WAITING:3,IN_PRODUCTION:4,IN_DELIVERY");

  const [settings, setSettings] = useState({
    tasktype: urlParams.getString('tasktype'),
    taskstatus: urlParams.getISelectArray('taskstatus', [{ label: 'TODO', value: 'todo' }]),
    sidx: urlParams.getSidx('prod_deadline'),
    sord: urlParams.getSord('asc'),
    customer: urlParams.getISelect('customer'),
    manager: urlParams.getISelect('manager'),
    query: urlParams.getString('query'),
    order_id: urlParams.getString('order_id'),
    status: urlParams.getISelectArray('status'),
    prod_deadline_start: urlParams.getString('prod_deadline_start'),
    prod_deadline_end: urlParams.getString('prod_deadline_end'),
    wood_part_type: urlParams.getISelect('wood_part_type_id'),
    walls_thickness: urlParams.getISelect('walls_thickness'),
  });

  const isManager = hasAnyRole(props.roles, [
    ROLES_LIST.SUPER_ADMIN,
    ROLES_LIST.PRODUCTION_WOODEN,
    ROLES_LIST.PRODUCTION_WINDOORS,
    ROLES_LIST.PACKING_MANAGER
  ])

  const
    [selectedItems, setSelectedItems] = useState(new Array<number>()),
    [totalLength, setTotalLength] = useState(0),
    [projects, setProjects] = useState(new Array<ProjectData>()),
    [customers, setCustomers] = useState(new Array<ISelectOption>()),
    [managers, setManagers] = useState(new Array<ISelectOption>()),
    [statuses, setStatuses] = useState(new Array<ISelectOption>()),
    [wallsThicknesses, setWallsThicknesses] = useState(new Array<ISelectOption>()),
    handleCheckboxClick = (project: ProjectData, checked: boolean) => {
      if (checked) {
        setSelectedItems([...selectedItems, project.id])
      } else {
        setSelectedItems(selectedItems.filter(n => n != project.id))
      }
    },
    handleRefreshClick = () => {
      loadData()
    };



  function statusesUpdated() {
    setSelectedItems([])
    loadData();
  }

  function sortBy(column: string): void {
    if (settings.sidx === column) {
      const newdir = (settings.sord === 'desc' ? 'asc' : 'desc')
      setSettings({ ...settings, sord: newdir })
    }
    else {
      setSettings({ ...settings, sidx: column })
    }
  }

  function getSortIcon(column: string): string {
    if (column === settings.sidx) {
      return (settings.sord === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up');
    }
    else {
      return 'fa fa-sort';
    }
  }

  function loadFiltersData() {
    Axios({ url: `/project_tasks/fdata.json` })
      .then((res) => {
        setCustomers(res.data.customers)
        setManagers(res.data.managers)
        setStatuses(res.data.statuses)
        setWallsThicknesses(res.data.walls_thicknesses)

      })
      .catch((err) => {
        console.log(err)
      })
  }


  function loadData() {
    let url_params = `tasktype=${settings.tasktype}&rows=${ALL_ROWS}&page=1&sidx=${settings.sidx}&sord=${settings.sord}`;

    if (settings.tasktype !== TT_WOODEN_PARTS && settings.taskstatus.length > 0) {
      const ts_all = settings.taskstatus.map((st) => `${st.value},${st.label}`).join(":")
      url_params = `${url_params}&taskstatus=${ts_all}`
    }

    if (settings.tasktype === TT_WOODEN_PARTS && settings.walls_thickness) {
      url_params = `${url_params}&walls_thickness=${settings.walls_thickness.value},${settings.walls_thickness.label}`
    }

    if (settings.customer) {
      url_params = `${url_params}&customer=${settings.customer.value},${settings.customer.label}`
    }
    if (settings.manager) {
      url_params = `${url_params}&manager=${settings.manager.value},${settings.manager.label}`
    }
    if (settings.status.length > 0) {
      const st_all = settings.status.map((st) => `${st.value},${st.label}`).join(":")
      url_params = `${url_params}&status=${st_all}`
    }
    if (`${settings.order_id}`.length > 0) {
      url_params = `${url_params}&order_id=${settings.order_id}`
    }
    if (`${settings.query}`.length > 0) {
      url_params = `${url_params}&query=${settings.query}`
    }
    if (`${settings.prod_deadline_start}`.length > 0) {
      url_params = `${url_params}&prod_deadline_start=${settings.prod_deadline_start}`
    }
    if (`${settings.prod_deadline_end}`.length > 0) {
      url_params = `${url_params}&prod_deadline_end=${settings.prod_deadline_end}`
    }
    if (settings.tasktype === TT_WOODEN_PARTS && settings.wood_part_type) {
      url_params = `${url_params}&wood_part_type_id=${settings.wood_part_type.value},${settings.wood_part_type.label}`
    }
    props.history.push(`${props.location.pathname}?${url_params}`)

    const requestId = ++requestIdRef.current;

    Axios({
      method: 'GET',
      url: `/project_tasks/data.json?${url_params}`,
      headers: {
        accept: 'application/json'
      }
    })
      .then((res) => {
        if (requestId !== requestIdRef.current) {
          // a newer request has since been issued; ignore this stale response
          return;
        }
        if (res.data.projects.length > 0) {
          setProjects(res.data.projects)
          setTotalLength(res.data.records)
        } else {
          setProjects([])
          setTotalLength(0)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  function searchByOrderId(newVal: string) {
    if (settings.order_id !== newVal) {
      setSettings({ ...settings, order_id: newVal })
    }
  }

  function searchByQuery(newVal: string) {
    if (settings.query !== newVal) {
      setSettings({ ...settings, query: newVal })
    }
  }

  function handleProdDeadlineRangeChange(dates: [Date | null, Date | null]): void {
    setSettings({
      ...settings,
      page: 1,
      prod_deadline_start: dates[0] ? formatDate(dates[0]) : '',
      prod_deadline_end: dates[1] ? formatDate(dates[1]) : '',
    });
  }

  function handleWoodPartTypeChange(opt: ISelectOption): void {
    setSettings({ ...settings, page: 1, wood_part_type: opt ?? null })
  }

  function handleWallsThicknessChange(opt: ISelectOption): void {
    setSettings({ ...settings, page: 1, walls_thickness: opt ?? null })
  }

  function visibleItems(): React.ReactNode[] {
    return projects.map((n) => (
      <TableRowDefault
        key={n.id}
        project={n}
        tasktype={settings.tasktype}
        isChecked={selectedItems.find(i => { return i === n.id || false }) !== undefined}
        onCheckboxClick={handleCheckboxClick}
        onTruckUpdated={loadData}
      />
    ))
  }

  function visibleWoodPartItems(): React.ReactNode[] {
    return projects.map((n) => (
      <TableRowWoodParts
        key={n.id}
        project={n}
        isChecked={selectedItems.find(i => { return i === n.id || false }) !== undefined}
        onCheckboxClick={handleCheckboxClick}
        onTruckUpdated={loadData}
      />
    ))
  }

  function handleCustomerChange(opt: ISelectOption): void {
    if (opt) {
      setSettings({ ...settings, customer: opt })
    } else {
      setSettings({ ...settings, customer: null })
    }
  }

  function handleManagerChange(opt: ISelectOption): void {
    if (opt) {
      setSettings({ ...settings, manager: opt })
    } else {
      setSettings({ ...settings, manager: null })
    }
  }

  function handleTaskStatusChange(opt: ISelectOption[]): void {
    setSettings({ ...settings, taskstatus: opt || [] })
  }

  function handleStatusChange(opt: ISelectOption[]): void {
    if (opt) {
      setSettings({ ...settings, status: opt })
    } else {
      setSettings({ ...settings, status: null })
    }
  }

  useEffect(() => {
    loadData();
  }, [settings])

  useEffect(() => {
    loadFiltersData();
  }, [])

  return (
    <div className="wrapper wrapper-content">

      <div className="ibox-content m-b-sm border-bottom">
        <div className="row">
          <div className="col-lg-12 animated fadeInRight">
            <h2>Tasks ({totalLength})</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-2">
            <TextSearchField
              inputText={settings.query}
              placeholder={"Project ID or name"}
              searchBy={searchByQuery} ></TextSearchField>
          </div>
          <div className="col-sm-1">
            <TextSearchField
              inputText={settings.order_id}
              placeholder={"Order Id"}
              searchBy={searchByOrderId} ></TextSearchField>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <Select
                isClearable
                placeholder="Customer"
                options={customers}
                defaultValue={settings.customer}
                onChange={val => handleCustomerChange(val)}
              />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <Select
                isClearable
                placeholder="Sales manager"
                options={managers}
                defaultValue={settings.manager}
                onChange={val => handleManagerChange(val)}
              />
            </div>
          </div>

          {settings.tasktype !== TT_WOODEN_PARTS && (
            <div className="col-sm-2">
              <div className="form-group">
                <Select
                  isMulti
                  placeholder="Progress"
                  options={AllProgressStatuses}
                  defaultValue={settings.taskstatus}
                  onChange={val => handleTaskStatusChange(val)}
                />
              </div>
            </div>
          )}

          {settings.tasktype === TT_WOODEN_PARTS && (
            <div className="col-sm-2">
              <div className="form-group">
                <Select
                  isClearable
                  placeholder="Wall thickness"
                  options={wallsThicknesses}
                  defaultValue={settings.walls_thickness}
                  onChange={val => handleWallsThicknessChange(val)}
                />
              </div>
            </div>
          )}

          <div className="col-sm-2">
            <div className="form-group">
              <Select
                isMulti
                placeholder="State"
                options={statuses}
                defaultValue={settings.status}
                onChange={val => handleStatusChange(val)}
              />
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group">
              <DateRangeSelect
                label="Prod Deadline"
                endDate={
                  settings.prod_deadline_end
                    ? new Date(settings.prod_deadline_end.replaceAll("-", "/"))
                    : null
                }
                startDate={
                  settings.prod_deadline_start
                    ? new Date(settings.prod_deadline_start.replaceAll("-", "/"))
                    : null
                }
                onDatesChange={handleProdDeadlineRangeChange}
              />
            </div>
          </div>

          {settings.tasktype === TT_WOODEN_PARTS && (
            <div className="col-sm-2">
              <div className="form-group">
                <Select
                  isClearable
                  placeholder="Type"
                  options={WOOD_PART_TYPES}
                  defaultValue={settings.wood_part_type}
                  onChange={val => handleWoodPartTypeChange(val)}
                />
              </div>
            </div>
          )}

        </div>
      </div>


      <div className="row">
        <div className="col-lg-12 animated fadeInRight">
          <div className="mail-box scrollable-table-box">
            <table className="footable table table-hover table-mail footable-loaded sticky-header-footer">

              <SearchContext.Provider value={{ sortBy: sortBy, getSortIcon: getSortIcon }}>
                {settings.tasktype !== TT_WOODEN_PARTS && <HeaderDefault tasktype={settings.tasktype} />}
                {settings.tasktype === TT_WOODEN_PARTS && <HeaderWoodParts />}
              </SearchContext.Provider>
              <tbody>
                {settings.tasktype === TT_WOODEN_PARTS && visibleWoodPartItems()}
                {settings.tasktype !== TT_WOODEN_PARTS && visibleItems()}
              </tbody>
            </table>
          </div>
        </div>
      </div>


      {
        hasAnyRole(props.roles, []) &&
        <div className="ibox">
          <div className="ibox-content">
            {
              isManager &&
              <BottomMenu
                selectedItems={selectedItems}
                projects={projects}
                tasktype={settings.tasktype}
                taskstatus={settings.taskstatus}
                statusesUpdated={statusesUpdated}
              ></BottomMenu>
            }

          </div>

        </div>

      }

    </div >
  )
}

export default List
